// src/App.js
import React from 'react';
// We no longer import 'BrowserRouter' here.
import { Routes, Route } from 'react-router-dom';

// Import all the components your routes need.
import Navbar from './components/common/Navbar';
import Alert from './components/common/Alert';
import HomePage from './components/core/HomePage';
import LoginScreen from './components/auth/LoginScreen';
import Dashboard from './components/core/Dashboard';
import GuestDashboard from './components/core/GuestDashboard';
import AdminDashboard from './components/admin/AdminDashboard';
import ProtectedRoute from './components/core/ProtectedRoute';
import ExternalRedirect from './components/core/ExternalRedirect';
import MeetingRouteWrapper from './components/core/MeetingRouteWrapper';

// The App component is now much cleaner.
function App() {
  return (
    // The <Router> and providers have been removed from this file.
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Alert />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/meet/:id" element={<MeetingRouteWrapper />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/guest-dashboard" element={<GuestDashboard />} />
          <Route path="/admin" element={
            <ProtectedRoute adminOnly={true}>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/docs" element={<ExternalRedirect to="https://github.com/your-repo/docs" />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
